import './madmexicantacohouse/style';
import FormStructure from './madmexicantacohouse/form_structure';

export default FormStructure;



// WEBPACK FOOTER //
// /Users/leila/dev/inquiry-renderer/client_forms/includes.js